export const NO_DATA_WARNING = 'No data available for your selected filters, try modifying your selections.';
